export default __webpack_public_path__ + "static/RandD-23943db8fb4de37717e09a349bf0faea.png";